import bannerUpdateCO from "../../../assets/images/updateDataCampaign/banner-update-data-co.jpg"
import bannerUpdateCO_Mobile from "../../../assets/images/updateDataCampaign/banner-update-data-co-MB.jpg"

import bannerUpdateEC from "../../../assets/images/updateDataCampaign/ec/banner-update-data-ec.png"
import bannerUpdateEC_Mobile from "../../../assets/images/updateDataCampaign/ec/banner-update-data-ec-MB.png"

import bannerUpdateCL from "../../../assets/images/updateDataCampaign/cl/banner-update-data-cl.png"
import bannerUpdateCL_Mobile from "../../../assets/images/updateDataCampaign/cl/banner-update-data-cl-MB.png"

import bannerUpdateAR from "../../../assets/images/updateDataCampaign/ar/banner-update-data-ar.png"
import bannerUpdateAR_Mobile from "../../../assets/images/updateDataCampaign/ar/banner-update-data-ar-MB.png"

import bannerUpdateBO from "../../../assets/images/updateDataCampaign/bo/banner-update-data-bo.png"
import bannerUpdateBO_Mobile from "../../../assets/images/updateDataCampaign/bo/banner-update-data-bo-MB.png"

import bannerFooterUpdateCO from "../../../assets/images/updateDataCampaign/banner-footer-update-data-co.png"
import bannerFooterUpdateCO_Mobile from "../../../assets/images/updateDataCampaign/banner-footer-update-data-co-MB.jpg"

import bannerFooterUpdateCL from "../../../assets/images/updateDataCampaign/cl/banner-footer-update-data-cl.png"
import bannerFooterUpdateCL_Mobile from "../../../assets/images/updateDataCampaign/cl/banner-footer-update-data-cl-MB.png"

import bannerFooterUpdateAR from "../../../assets/images/updateDataCampaign/ar/banner-footer-update-data-ar.png"
import bannerFooterUpdateAR_Mobile from "../../../assets/images/updateDataCampaign/ar/banner-footer-update-data-ar-MB.png"

import bannerFooterUpdateBO from "../../../assets/images/updateDataCampaign/bo/banner-footer-update-data-bo.png"
import bannerFooterUpdateBO_Mobile from "../../../assets/images/updateDataCampaign/bo/banner-footer-update-data-bo-MB.png"

import bannerUpdatePe from "../../../assets/images/updateDataCampaign/pe/banner-update-data-pe.png"
import bannerUpdatePe_Mobile from "../../../assets/images/updateDataCampaign/pe/banner-update-data-pe-MB.png"
import bannerFooterUpdatePE from "../../../assets/images/updateDataCampaign/pe/banner-footer-update-data-pe.png"
import bannerFooterUpdatePE_Mobile from "../../../assets/images/updateDataCampaign/pe/banner-footer-update-data-pe-MB.png"

export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : "DEV"

export default {
  "es-CO": {
    idActivity: { DEV: 432, PDN: 473 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateCO,
      imgMobile: bannerUpdateCO_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateCO,
      imgMobile: bannerFooterUpdateCO_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    labelButton: 'Hazlo aquí'
  },
  //replicas actualizacion de datos
  "es-EC": {
    idActivity: { DEV: 442, PDN: 489 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateEC,
      imgMobile: bannerUpdateEC_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateCO,
      imgMobile: bannerFooterUpdateCO_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    labelButton: 'Hazlo aquí'
  },
  "es-CL": {
    idActivity: { DEV: 443, PDN: 507 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateCL,
      imgMobile: bannerUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateCL,
      imgMobile: bannerFooterUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    labelButton: 'Hazlo aquí'
  },
  "es-PR": {
    idActivity: { DEV: 445, PDN: 503 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateCL,
      imgMobile: bannerUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateCL,
      imgMobile: bannerFooterUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    labelButton: 'Hazlo aquí'
  },
  "es-DO": {
    idActivity: { DEV: 444, PDN: 491 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateCL,
      imgMobile: bannerUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateCL,
      imgMobile: bannerFooterUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    labelButton: 'Hazlo aquí',
  },
  "es-PY": {
    idActivity: { DEV: 446, PDN: 495 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateCL,
      imgMobile: bannerUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateCL,
      imgMobile: bannerFooterUpdateCL_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui y ganaras 50 puntos",
    },
    labelButton: 'Hazlo aquí',
  },
  "es-AR": {
    idActivity: { DEV: 440, PDN: 493 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateAR,
      imgMobile: bannerUpdateAR_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hacélo aqui y ganaras 50 puntos",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateAR,
      imgMobile: bannerFooterUpdateAR_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hacélo aqui y ganaras 50 puntos",
    },
    labelButton: 'Hacelo acá',
  },
  "es-BO": {
    idActivity: { DEV: 441, PDN: 504 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdateBO,
      imgMobile: bannerUpdateBO_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdateBO,
      imgMobile: bannerFooterUpdateBO_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui",
    },
    labelButton: 'Hazlo aquí',
  },
  "es-PE": {
    idActivity: { DEV: 455, PDN: 502 }[ENV],
    headerImage: {
      imgDesktop: bannerUpdatePe,
      imgMobile: bannerUpdatePe_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui",
    },
    bannerFooter: {
      imgDesktop: bannerFooterUpdatePE,
      imgMobile: bannerFooterUpdatePE_Mobile,
      description:
        "llego la actualizacion de datos al portal de nosotras, hazlo aqui",
    },
    labelButton: 'Hazlo aquí',
  },
}

const toDate = str => {
  const date = new Date();
  let strsplit = str.split("/");
  date.setFullYear(strsplit[2]);
  date.setMonth(parseInt(strsplit[1])-1);//month -1 cuz 0=enero
  date.setDate(strsplit[0]);
  return date
}
const calcDaysDiff = strdate => {
  const date = toDate(strdate); 
  let difference = date.getTime() - Date.now()
  return Math.ceil(difference / (1000 * 3600 * 24))
}
const canDeployOnDate=strdate=>{
  return calcDaysDiff(strdate)>=0
}
const countryDatesDeploy = {
  "es-CO": canDeployOnDate("18/11/2022"),
  "es-EC": canDeployOnDate("30/12/2022"),
  "es-DO": canDeployOnDate("11/11/2022"),
  "es-AR": canDeployOnDate("12/11/2022"),
  "es-PY": canDeployOnDate("18/11/2022"),
  "es-CL": canDeployOnDate("8/1/2023"),
  "es-PR": canDeployOnDate("26/11/2022"),
  "es-BO": canDeployOnDate("26/11/2022"),
  "es-PE": canDeployOnDate("27/11/2022"),
}
// -- console.log("countryDatesDeploy", countryDatesDeploy);
 

// export const countryDeploys = {
//   DEV: ["es-CO", "es-EC", "es-CL", "es-PR", "es-DO", "es-PY", "es-AR", "es-BO", 'es-PE'],
//   PDN: [ "es-EC",  "es-PR", "es-BO", "es-CL"], //"es-DO",,"es-AR","es-CO","es-PY", 
// }[ENV]; 
 
//export const canIDeployOnThisCountry = countryDeploys.includes(process.env.LOCALE);
export const canIDeployOnThisCountry =countryDatesDeploy[process.env.LOCALE] || false